import { render, staticRenderFns } from "./TheNavbarHorizontal.vue?vue&type=template&id=33aaa3c2&scoped=true"
import script from "./TheNavbarHorizontal.vue?vue&type=script&lang=js"
export * from "./TheNavbarHorizontal.vue?vue&type=script&lang=js"
import style0 from "./TheNavbarHorizontal.vue?vue&type=style&index=0&id=33aaa3c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aaa3c2",
  null
  
)

export default component.exports